export default __webpack_public_path__ + "static/media/Certificat - OpenClassrooms.602a9066.png";